export const GET_AP_SESSION_DURATION = 'GET_AP_SESSION_DURATION';
export const GET_AP_SESSION_DURATION_SUCCESS = 'GET_AP_SESSION_DURATION_SUCCESS';
export const GET_AP_SESSION_DURATION_FAIL = 'GET_AP_SESSION_DURATION_FAIL';
export const GET_AP_SESSION_DURATION_SUCCESS_MSG =
	'SESSION_DURATION_RETRIEVED_SUCCESSFULLY';

export const GET_AP_CPU = 'GET_AP_CPU';	
export const GET_AP_CPU_SUCCESS = 'GET_AP_CPU_SUCCESS';	
export const GET_AP_CPU_FAIL = 'GET_AP_CPU_FAIL';	

export const GET_UPLINK_RATE_GRAPH = 'GET_UPLINK_RATE_GRAPH';	
export const GET_UPLINK_RATE_GRAPH_SUCCESS = 'GET_UPLINK_RATE_GRAPH_SUCCESS';	
export const GET_UPLINK_RATE_GRAPH_FAIL = 'GET_UPLINK_RATE_GRAPH_FAIL';	

export const GET_DOWNLINK_RATE_GRAPH = 'GET_DOWNLINK_RATE_GRAPH';	
export const GET_DOWNLINK_RATE_GRAPH_SUCCESS = 'GET_DOWNLINK_RATE_GRAPH_SUCCESS';	
export const GET_DOWNLINK_RATE_GRAPH_FAIL = 'GET_DOWNLINK_RATE_GRAPH_FAIL';	